import {useRouter} from "next/router";
import PropTypes from "prop-types";
import Image from "next/image";

const SocialBlock = ({name, work, image}) => {
  const {basePath} = useRouter();

  return (
    <div className='author-block__author-block' style={{ backgroundImage: `url(${basePath}/images/BG.png)` }}>
      <Image src={`${basePath}/images/${image}`} width={120} height={120} alt=""/>
      <div>
        <p className='author-block__author-text'>{name}</p>
        <p className='author-block__small-text'>{work}</p>
      </div>
    </div>
  )
}

SocialBlock.propTypes = {
  name: PropTypes.string.isRequired,
  image: PropTypes.string.isRequired,
  work: PropTypes.string.isRequired,
};

export default SocialBlock;
